'use strict';


import $ from 'jquery';
import * as globalisation from '../../utilities/globalisation';
import MarketingTracking from '../MarketingTracking/MarketingTracking';
import config from '../../js/config';
import Analytics from  '../Analytics/Analytics';
import Backbone from 'backbone';
import userService from '../../services/CartUserService';
import mediator from '../../js/mediator';

var ContactUsV2EmailView = Backbone.View.extend({
  events: {
    'click #ContactUs-EmailForm-helpList-input': 'helpListSelected',
    'click #ContactUs-EmailForm-returnReasonList-input': 'returnReasonListSelected',
    'change select#ContactUs-EmailForm-returnReasonList-input': 'returnReasonListSelected',
    'change select#ContactUs-EmailForm-helpList-input': 'getDefaultDescription',
    'click #ContactUs-EmailForm-description-input': 'emailDescriptionChanged',
    'click #ContactUs-EmailForm-submit': 'submitData'
  },

  initialize: function(input) {
    this.userData = input.userData;
    this.$emailConfirmation = $('.ContactUs-EmailForm-confirmation');
    this.$form = this.$el.find('form');
    this.MarketingTracking = new MarketingTracking();
    this.$helpListDropDown = this.$form.find('#ContactUs-EmailForm-helpList-input');
    this.$returnListDropDown = this.$form.find('#ContactUs-EmailForm-returnReasonList-input');
    this.$emailFormDescription = this.$form.find('#ContactUs-EmailForm-description-input');
    this.$returnSection = this.$form.find('.ContactUs-EmailForm-returns-section');
    this.$salesOrderNumber = this.$form.find('.ContactUs-EmailForm-salesOrderNumber');
    if (this.$emailFormDescription[0] !== undefined) {
      this.$emailFormDescription[0].value = '';
    }
    this.defaultReturnSectionClass = 'ContactUs-EmailForm-returns-section-default';
    this.$loggedInUserClass = $('.ContactUs-loggedInUser-text');
    this.$emailFormUserNotLoggedInSection = this.$form.find('.ContactUs-EmailForm-userNotLoggedIn-section');
    this.$submitButton = this.$el.find('#ContactUs-EmailForm-submit');
    this.userIsLoggedIn = window.Arrow.isAuthorized;
    mediator.on(config.events.registration.reCaptchaContactUsSucess, this.reCaptchaSuccessCallback, this);
    mediator.on(config.events.registration.mtCaptchaContactUsSucess, this.mtCaptchaSuccessCallback, this);
    window.onReCaptchaContactUsSubmit = this.reCaptchaCallback;
    window.onMTCaptchaSubmit = this.mtCaptchaCallback;
    this.mtCaptchaToken = '';
    this.token = '';
    this.toggleUserNotLoggedInSection();
  },
  toggleUserNotLoggedInSection: function() {
    let userGreeting = globalisation.pluraliseAndTranslate('customerSupport', 'loggedInUserGreeting');
    if (this.userData && this.userData.firstName) {
      userGreeting = userGreeting + ' ' + this.userData.firstName + ',';
      this.$loggedInUserClass.html(userGreeting);
    }
    else {
      this.$emailFormUserNotLoggedInSection.removeClass('ContactUs-EmailForm-userNotLoggedIn-default');
    }
  },
  returnReasonListSelected: function(e) {
    e.preventDefault();
    this.$returnListDropDown.removeClass('ContactUs-EmailForm-returnListDropDown-default');
    this.$returnListDropDown.addClass('ContactUs-EmailForm-helpList-selected');
  },
  helpListSelected: function(e) {
    e.preventDefault();
    this.$helpListDropDown.removeClass('ContactUs-EmailForm-helpList-default');
    this.$helpListDropDown.addClass('ContactUs-EmailForm-helpList-selected');
  },
  disableReturnsSection: function() {
    if (!this.$salesOrderNumber.hasClass('ContactUs-EmailForm-salesOrderNumber-default')) {
      this.$salesOrderNumber.addClass('ContactUs-EmailForm-salesOrderNumber-default');
      this.$returnSection.addClass(this.defaultReturnSectionClass);
    }
  },
  reCaptchaCallback(token) {
    mediator.trigger(config.events.registration.reCaptchaContactUsSucess, token);
  },
  mtCaptchaCallback(state) {
    mediator.trigger(config.events.registration.mtCaptchaContactUsSucess, state.verifiedToken);
  },
  reCaptchaSuccessCallback(token) {
    this.token = token;
    if (this.$submitButton.hasClass('ContactUs-EmailForm-hidden')) {
      this.$submitButton.removeClass('ContactUs-EmailForm-hidden');
    }
    else {
      this.submitData();
      if (this.$form.valid()) {
        this.$form.submit();
      }
    }
  },
  mtCaptchaSuccessCallback(token) {
    this.mtCaptchaToken = token;
    if (this.$submitButton.hasClass('ContactUs-EmailForm-hidden')) {
      this.$submitButton.removeClass('ContactUs-EmailForm-hidden');
    }
  },
  getDefaultDescription: function(e) {
    this.helpListSelected(e);
    this.disableReturnsSection();
    this.selectedChoice = $('#ContactUs-EmailForm-helpList-input option:selected')[0].value;
    let defaultDescription = '';
    switch (this.selectedChoice) {
      case 'ORDERSTATUS' :
        this.$salesOrderNumber.removeClass('ContactUs-EmailForm-salesOrderNumber-default');
        defaultDescription = globalisation.pluraliseAndTranslate('customerSupport', 'orderStatus');
        break;
      case 'ORDERCHANGE' :
        this.$salesOrderNumber.removeClass('ContactUs-EmailForm-salesOrderNumber-default');
        defaultDescription = globalisation.pluraliseAndTranslate('customerSupport', 'orderChange');
        break;
      case 'QUOTE' :
        defaultDescription = globalisation.pluraliseAndTranslate('customerSupport', 'quote');
        break;
      case 'RETURNREQUEST' :
        this.$salesOrderNumber.removeClass('ContactUs-EmailForm-salesOrderNumber-default');
        this.$returnSection.removeClass(this.defaultReturnSectionClass);
        defaultDescription = globalisation.pluraliseAndTranslate('customerSupport', 'returnRequest');
        break;
      case 'ARRANGEPAYMENT' :
        this.$salesOrderNumber.removeClass('ContactUs-EmailForm-salesOrderNumber-default');
        defaultDescription = globalisation.pluraliseAndTranslate('customerSupport', 'arrangePayment');
        break;
      case 'QUESTION' :
        defaultDescription = globalisation.pluraliseAndTranslate('customerSupport', 'question');
        break;
      case 'ISSUES' :
        defaultDescription = globalisation.pluraliseAndTranslate('customerSupport', 'issues');
        break;
      case 'FEEDBACK' :
        defaultDescription = globalisation.pluraliseAndTranslate('customerSupport', 'feedback');
        break;
      case 'OTHER' :
        defaultDescription = globalisation.pluraliseAndTranslate('customerSupport', 'other');
        break;
    }
    this.$emailFormDescription[0].value = defaultDescription;
    this.$emailFormDescription.addClass('ContactUs-EmailForm-helpList-default');
  },

  updateEmailDescriptionField: function() {
    if (this.$emailFormDescription.hasClass('ContactUs-EmailForm-helpList-default')) {
      this.$emailFormDescription[0].value = '';
      this.$emailFormDescription.removeClass('ContactUs-EmailForm-helpList-default');
      this.$emailFormDescription.addClass('ContactUs-EmailForm-helpList-selected');
    }
  },

  emailDescriptionChanged: function() {
    this.updateEmailDescriptionField();
  },

  submitData: function() {
    this.updateEmailDescriptionField();
    $.validator.addMethod(
      'nameValidation',
      function(value, element, regexp) {
        var re = new RegExp(regexp);
        return this.optional(element) || re.test(value);
      },
      globalisation.pluraliseAndTranslate('customerSupport', 'nameValidation')
    );
    $.validator.addMethod(
      'orderNumberValidation',
      function(value, element, regexp) {
        let re = new RegExp(regexp);
        return this.optional(element) || re.test(value);
      },
      globalisation.pluraliseAndTranslate('customerSupport', 'orderNumberValidation')
    );
    this.$form.validate({
      rules: {
        'ContactUs-EmailForm-firstName-input': {
          nameValidation: '^[a-zA-Z]([a-zA-Z\s-]*[a-zA-Z\s])?$'
        },
        'ContactUs-EmailForm-lastName-input': {
          nameValidation: '^[a-zA-Z]([a-zA-Z\s-]*[a-zA-Z\s])?$'
        },
        'ContactUs-EmailForm-salesOrderNumber-input': {
          orderNumberValidation: '^[a-zA-Z]([a-zA-Z0-9\s-]*[a-zA-Z0-9\s])?$'
        }
      },
      submitHandler: () => {
        let userData =  this.MarketingTracking.getCompanyUserDetails();
        let returnRequestOptionSelected = $('#ContactUs-EmailForm-returnReasonList-input option:selected')[0].value;
        let formData = {
          helpListOptionSelected: this.selectedChoice,
          description: document.getElementById('ContactUs-EmailForm-description-input').value,
          utmCampaign: (document.location.href.indexOf('utm_campaign__c') !== -1) ? document.location.href.indexOf('utm_campaign__c') : '',
          utmContentc: (document.location.href.indexOf('utm_content__c') !== -1) ? document.location.href.indexOf('utm_content__c') : '',
          utmMedium: (document.location.href.indexOf('utm_medium__c') !== -1) ? document.location.href.indexOf('utm_medium__c') : '',
          utmSource: (document.location.href.indexOf('utm_source__c') !== -1) ? document.location.href.indexOf('utm_source__c') : '',
          utmTermc: (document.location.href.indexOf('utm_term__c') !== -1) ? document.location.href.indexOf('utm_term__c') : '',
          countryOrigin: userData.country,
          auid: userData.userId,
          gid: userData.userAnonymousIdGids[0],
          gid2: userData.userAnonymousIdGids[1],
          ga: userData.userAnonymousIdGAs[0],
          ga2: userData.userAnonymousIdGAs[1],
          language: userData.preferredLanguage,
          reCaptchaToken: this.token,
          mtCaptchaToken: this.mtCaptchaToken
        };
        if (this.userIsLoggedIn && this.userData.firstName) {
          formData.firstName = this.userData.firstName;
          formData.company = this.userData.company;
          formData.lastName = this.userData.lastName;
          formData.email = this.userData.email;
        } else {
          formData.firstName = document.getElementById('ContactUs-EmailForm-firstName-input').value;
          formData.lastName = document.getElementById('ContactUs-EmailForm-lastName-input').value;
          formData.email = document.getElementById('ContactUs-EmailForm-email-input').value;
        }
        formData.subject = 'Arrow.com Support Request - ' + formData.firstName + ' ' + formData.lastName;
        if (document.getElementById('ContactUs-EmailForm-salesOrderNumber-input').value) {
          formData.salesOrderNumber = document.getElementById('ContactUs-EmailForm-salesOrderNumber-input').value;
        }
        if (returnRequestOptionSelected) {
          formData.returnRequestOptionSelected = returnRequestOptionSelected;
        }
        let analyticsEventData = {
          event: config.analytics.events.click,
          category: config.analytics.categoryTypes.Support,
          action: config.analytics.actions.ContactArrow,
          label: config.analytics.labelTypes.EmailUsClick
        };
        Analytics.pushToEventFramework(analyticsEventData);
        this.track(formData);
      }
    });
  },

  track(formData) {
    $.ajax({
      type: 'POST',
      url: config.urls.contactSupport.emailUs ,
      data: { emailUsFormData: JSON.stringify(formData)},
      dataType: 'json'
    })
      .done(() => {
        this.$form.trigger('reset');
        this.disableReturnsSection();
        this.$emailConfirmation.removeClass('ContactUs-EmailForm-confirmation-default');
      })
      .fail(() => {
      });
  }
});

export { ContactUsV2EmailView };

export function createContactUsEmailForm($parent) {
  userService.getUserInfo().then((userData) => {
    $parent.find('.Content .ContactUs-EmailForm').each((n, el) => new ContactUsV2EmailView({el, userData}))
  });
}



// WEBPACK FOOTER //
// ./assets/components/ContactUsV2/ContactUsV2EmailView.js